import { format } from "date-fns";

type DateOnlyValue = Date | string | null | undefined;

type DateOnlyParts = {
  year: number;
  month: number;
  day: number;
};

const DATE_ONLY_PATTERN = /^(\d{4})[-/](\d{2})[-/](\d{2})/;

const getDateOnlyParts = (value: DateOnlyValue): DateOnlyParts | null => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }

    return {
      year: value.getUTCFullYear(),
      month: value.getUTCMonth() + 1,
      day: value.getUTCDate(),
    };
  }

  const match = DATE_ONLY_PATTERN.exec(value);

  if (!match) {
    return null;
  }

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
};

const toLocalDate = (parts: DateOnlyParts) => {
  const date = new Date(parts.year, parts.month - 1, parts.day);

  if (
    date.getFullYear() !== parts.year ||
    date.getMonth() !== parts.month - 1 ||
    date.getDate() !== parts.day
  ) {
    return null;
  }

  return date;
};

export const formatDateOnly = (
  value: DateOnlyValue,
  dateFormat = "MMM dd, yyyy",
) => {
  const parts = getDateOnlyParts(value);

  if (!parts) {
    return "";
  }

  const date = toLocalDate(parts);

  return date ? format(date, dateFormat) : "";
};
